import { useSelector, useDispatch } from "react-redux";
import { setUser, logout } from "./currentUserSlice";
import type { SharedUser } from "./currentUserSlice";

/**
 * Minimal store shape expected by useCurrentUser.
 * Each frontend's RootState must satisfy this interface.
 */
interface MinimalRootState {
  currentUser: SharedUser | null;
}

/**
 * Hook to access and manage the current authenticated user.
 *
 * NOTE: This hook does NOT include `useUsuarioInfo` to avoid a circular
 * dependency with the hooks module. Each frontend should compose
 * `useCurrentUser` + `useUsuarioInfo` locally if needed.
 */
export const useCurrentUser = () => {
  const user = useSelector((state: MinimalRootState) => state.currentUser);
  const dispatch = useDispatch();

  return {
    user,
    setUser: (userData: Parameters<typeof setUser>[0]) =>
      dispatch(setUser(userData)),
    logout: () => dispatch(logout()),
  };
};
